/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CustomersService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List all customers linked to the trainer
     * @returns any List of customers
     * @throws ApiError
     */
    public getCustomers(): CancelablePromise<{
        customers: Array<{
            id: string;
            email: string;
            name: string | null;
            emailVerified: boolean;
            createdAt: string;
            accessToken: string | null;
            isClaimed: boolean;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/customers',
            errors: {
                403: `Only trainers can access this endpoint`,
            },
        });
    }

    /**
     * Create a new customer with access token
     * @returns any Customer created successfully
     * @throws ApiError
     */
    public postCustomers({
        requestBody,
    }: {
        requestBody?: {
            email: string;
            name?: string;
        },
    }): CancelablePromise<{
        customerId: string;
        email: string;
        accessToken: string;
        accessUrl: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/customers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Customer with this email already exists`,
                403: `Only trainers can create customers`,
            },
        });
    }

    /**
     * Delete customer (unlink from trainer)
     * @returns any Customer unlinked successfully
     * @throws ApiError
     */
    public deleteCustomers({
        customerId,
    }: {
        customerId: string,
    }): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/customers/{customerId}',
            path: {
                'customerId': customerId,
            },
            errors: {
                403: `Only trainers can delete customers`,
                404: `Customer link not found`,
            },
        });
    }

    /**
     * List all trainers linked to the customer
     * @returns any List of trainers
     * @throws ApiError
     */
    public getCustomersTrainers(): CancelablePromise<{
        trainers: Array<{
            id: string;
            email: string;
            name: string | null;
            createdAt: string;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/customers/trainers',
            errors: {
                403: `Only customers can access this endpoint`,
            },
        });
    }

}
